<template>
  <BModal
    id="modal-delete-organization"
    centered
    no-close-on-backdrop
    hide-footer
    hide-header
    size="md"
    @hidden="reset"
  >
    <div class="py-2 px-1 text-center">
      <!-- Icon/Image -->
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/popup-warning.png"
        alt="Warning"
        class="mx-auto mb-2"
        style="max-width: 120px;"
      >

      <!-- Title -->
      <h4 class="text-black font-bold mb-1">
        Hapus Organisasi?
      </h4>

      <!-- Subtitle -->
      <p class="text-[#6B7280] text-[14px] mb-4">
        Apakah kamu yakin ingin menghapus organisasi ini? Tindakan ini tidak dapat dibatalkan.
      </p>

      <!-- Footer Buttons -->
      <div class="flex items-center justify-center gap-2">
        <b-button
          variant="primary"
          class="!rounded-lg !px-6 !py-2 !bg-[#F95031] !border-[#F95031] flex-1"
          @click="$bvModal.hide('modal-delete-organization')"
        >
          Batal
        </b-button>
        <b-button
          variant="outline-secondary"
          class="!rounded-lg !px-6 !py-2 !border-[#E5E5E5] !text-black flex-1"
          :disabled="isSubmitting"
          @click="handleSubmit"
        >
          <b-spinner
            v-if="isSubmitting"
            small
            class="mr-1"
          />
          Hapus
        </b-button>
      </div>
    </div>
  </BModal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'

export default {
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isSubmitting: false,
    }
  },
  methods: {
    reset() {
      this.isSubmitting = false
    },
    handleSubmit() {
      this.isSubmitting = true
      const url = '/auth/api/v1/organizations'
      const params = {
        id_org: this.initialData.id_org,
      }

      newAxiosIns
        .delete(url, { data: params })
        .then(() => {
          this.$toast_success({ message: 'Berhasil menghapus organisasi' })
          this.$emit('submit')
        })
        .catch(err => {
          const capitalize = err?.response.data?.meta?.message.charAt(0).toUpperCase() + err?.response.data?.meta?.message.slice(1)
          this.$toast_error({ message: capitalize })
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
  },
}
</script>

<style scoped>

</style>
